var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderType, Grid } from '@syncfusion/ej2-grids';
import { DomVirtualization as GridDomVirtualization } from '@syncfusion/ej2-grids';
import { initialLoad, destroy } from '@syncfusion/ej2-grids';
import { DomVirtualTreeContentRenderer } from '../renderer/dom-virtual-tree-content-renderer';
import { getValue, initializeTelemetryFeature, isNullOrUndefined } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { getExpandStatus, isOffline, isRemoteData } from '../utils';
/**
 * TreeGrid DOM Virtualization module handles high-performance rendering of large hierarchical datasets.
 *
 * @hidden
 */
var DomVirtualization = /** @class */ (function () {
    /**
     * Constructor for DomVirtualization module
     *
     * @param {TreeGrid} parent - TreeGrid instance
     * @param {ServiceLocator} locator - Service locator for dependency injection
     */
    function DomVirtualization(parent, locator) {
        initializeTelemetryFeature('DomVirtualization', 'TreeGrid');
        this.parent = parent;
        this.locator = locator;
        Grid.Inject(DomVirtualTreeExtension);
        this.addEventListener();
    }
    DomVirtualization.prototype.getModuleName = function () {
        return 'domVirtualization';
    };
    /**
     * @hidden
     * @returns {void}
     */
    DomVirtualization.prototype.addEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(destroy, this.destroy, this);
        this.parent.on(events.virtualExpandCollapse, this.collapseExpandVirtualchilds, this);
        this.parent.on(events.pagingActions, this.virtualPageAction, this);
    };
    /**
     * @hidden
     * @returns {void}
     */
    DomVirtualization.prototype.removeEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(destroy, this.destroy);
        this.parent.off(events.virtualExpandCollapse, this.collapseExpandVirtualchilds);
        this.parent.off(events.pagingActions, this.virtualPageAction);
    };
    /**
     * Handles the action related to virtual scrolling with paging details.
     *
     * @param {Object} pageingDetails - Contains the result data, count of results, and action arguments.
     * @param {ITreeData[]} pageingDetails.result - The result data to be handled.
     * @param {number} pageingDetails.count - The count of results.
     * @param {ActionEventArgs} pageingDetails.actionArgs - The action arguments related to the virtual page action.
     * @returns {void}
     */
    DomVirtualization.prototype.virtualPageAction = function (pageingDetails) {
        var _this = this;
        var actionArgs = getValue('actionArgs', pageingDetails.actionArgs);
        var action = getValue('action', pageingDetails.actionArgs);
        var isFiltering = (pageingDetails.actionArgs.requestType === 'filtering' && (pageingDetails.actionArgs.action !== 'clear-filter' && pageingDetails.actionArgs.action !== 'clearFilter')) ||
            (!isNullOrUndefined(this.parent['filterModule']) && (this.parent['filterModule'].filteredResult && this.parent['filterModule'].filteredResult.length > 0));
        var isFlatHierarchy = this.parent.filterSettings.hierarchyMode === 'Child' ||
            this.parent.filterSettings.hierarchyMode === 'None';
        var parents = pageingDetails.result;
        parents = isFiltering && isFlatHierarchy ? parents.filter(function (e) {
            if (isNullOrUndefined(e.parentItem)) {
                return true;
            }
            var hasParentInFilteredList = parents.some(function (p) { return p.uniqueID === e.parentItem.uniqueID; });
            return hasParentInFilteredList ? getExpandStatus(_this.parent, e, parents) : true;
        }) : parents.filter(function (e) { return getExpandStatus(_this.parent, e, parents); });
        this.parent.virtualDomScrollData = parents;
        var dm = new DataManager(parents);
        this.visualData = parents;
        var query = new Query();
        if (this.parent.allowPaging || this.parent.enableVirtualization) {
            var take = isNullOrUndefined(actionArgs.requestType) || actionArgs.requestType === 'dom-virtualscroll' ?
                pageingDetails.actionArgs.result.length : pageingDetails.result.length;
            if (action === 'collapse') {
                take = this.parent.grid.currentViewData.length;
            }
            var skip = this.parent.grid.pageSettings.currentPage <= 1 ? 0 :
                (this.parent.grid.pageSettings.currentPage - 1) * this.parent.grid.pageSettings.pageSize;
            if (actionArgs.requestType === 'dom-virtualscroll') {
                var pagingQueries = (pageingDetails.actionArgs && pageingDetails.actionArgs.query
                    && pageingDetails.actionArgs.query.queries) || [];
                var takeQuery = pagingQueries.filter(function (q) { return q.fn === 'onTake'; });
                var explicitTake = takeQuery.length > 0
                    ? takeQuery[parseInt((takeQuery.length - 1).toString(), 10)] : undefined;
                if (!isNullOrUndefined(explicitTake) && typeof explicitTake.e.nos === 'number') {
                    take = explicitTake.e.nos;
                }
            }
            else if ((actionArgs.requestType === 'filtering' || actionArgs.requestType === 'searching') && skip > 0) {
                skip = 0;
                this.parent.grid.setProperties({ pageSettings: { currentPage: 1 } }, true);
            }
            query = query.skip(skip).take(take);
        }
        dm.dataSource.json = this.visualData;
        pageingDetails.result = dm.executeLocal(query);
        pageingDetails.count = this.visualData.length;
        this.parent.notify('updateAction', pageingDetails);
    };
    DomVirtualization.prototype.calculateChildCount = function (startIndex, level, records) {
        var count = 0;
        for (var i = startIndex; i < records.length; i++) {
            if (records[i + 1] && (level === records[i + 1].level || level === records[i + 1].level + 1)) {
                break;
            }
            count++;
        }
        return count;
    };
    /**
     * Handles the virtual child collapse or expand action in a tree grid.
     *
     * @param {object} row - Object containing information about the collapse/expand action.
     * @param {string} row.action - The type of action, either "collapse" or "expand".
     * @param {HTMLTableRowElement} row.row - The HTML row element that is affected by the action.
     * @param {ITreeData} row.record - The tree data record associated with the row.
     * @param {RowCollapsedEventArgs} row.args - Additional event arguments related to the row collapse or expand.
     *
     * @returns {void} No return value as the function executes a procedure.
     */
    DomVirtualization.prototype.collapseExpandVirtualchilds = function (row) {
        var contentModule = this.parent.grid.contentModule;
        var isRemote = isRemoteData(this.parent) && !isOffline(this.parent);
        var flatData = isRemote ? this.parent.getCurrentViewRecords() : this.parent.enableVirtualization ?
            this.parent.virtualDomScrollData.slice() : this.parent.grid.currentViewData.slice();
        var totalflatData = this.parent.infiniteScrollData;
        var uniqueIDCollpaseCollection = this.parent.uniqueIDCollpaseCollection;
        var startIndex = contentModule.currentStartIndex;
        if (getValue('isCollapseAll', this.parent) || getValue('isExpandAll', this.parent)) {
            if (row.action === 'collapse') {
                flatData.filter(function (e) {
                    if (e.hasChildRecords) {
                        e.expanded = row.action === 'collapse' ? false : true;
                    }
                });
                flatData.splice.apply(flatData, [0, flatData.length].concat(this.parent.parentData));
                // this.parent.pageSettings.totalRecordsCount = this.parent.parentData.length;
            }
            else {
                totalflatData.filter(function (e) {
                    if (e.hasChildRecords) {
                        e.expanded = row.action === 'collapse' ? false : true;
                    }
                });
                flatData.splice.apply(flatData, [0, flatData.length].concat(totalflatData));
                // this.parent.pageSettings.totalRecordsCount = totalflatData.length;
            }
        }
        else {
            row.record.expanded = row.action === 'collapse' ? false : true;
            for (var i = startIndex; i < flatData.length; i++) {
                if (row.record.uniqueID === flatData[parseInt(i.toString(), 10)].uniqueID &&
                    row.record.childRecords.length > 0) {
                    if (row.action === 'collapse') {
                        var level = flatData[parseInt(i.toString(), 10)].level;
                        var count = this.calculateChildCount(i, level, flatData);
                        // this.parent.pageSettings.totalRecordsCount -= count;
                        uniqueIDCollpaseCollection[row.record.uniqueID] = flatData.splice(i + 1, count);
                    }
                    else {
                        if (uniqueIDCollpaseCollection[row.record.uniqueID] && uniqueIDCollpaseCollection[row.record.uniqueID].length) {
                            flatData.splice.apply(flatData, [i + 1, 0].concat(uniqueIDCollpaseCollection[row.record.uniqueID]));
                            // this.parent.pageSettings.totalRecordsCount += uniqueIDCollpaseCollection[row.record.uniqueID].length;
                        }
                        else {
                            uniqueIDCollpaseCollection[row.record.uniqueID] = row.record.childRecords;
                            flatData.splice.apply(flatData, [i + 1, 0].concat(uniqueIDCollpaseCollection[row.record.uniqueID]));
                            // this.parent.pageSettings.totalRecordsCount += uniqueIDCollpaseCollection[row.record.uniqueID].length;
                        }
                    }
                    break;
                }
            }
        }
        var actionDetails = {
            result: flatData,
            row: row.row,
            action: row.action,
            record: row.record,
            count: flatData.length
        };
        getValue('grid.renderModule', this.parent).dataManagerSuccess(actionDetails, { requestType: 'refresh' });
    };
    DomVirtualization.prototype.destroy = function () {
        this.removeEventListener();
    };
    return DomVirtualization;
}());
export { DomVirtualization };
var DomVirtualTreeExtension = /** @class */ (function (_super) {
    __extends(DomVirtualTreeExtension, _super);
    /**
     * Constructor for DomVirtualTreeExtension
     *
     * @param {IGrid} parent - Grid instance (actually TreeGrid)
     * @param {ServiceLocator} locator - Service locator for dependency injection
     */
    function DomVirtualTreeExtension(parent, locator) {
        var _this = _super.call(this, parent, locator) || this;
        getValue('parent', _this).off(initialLoad, getValue('instantiateRenderer', _this), _this);
        getValue('parent', _this).on(initialLoad, _this.instantiateRenderers, _this);
        return _this;
    }
    DomVirtualTreeExtension.prototype.getModuleName = function () {
        return 'treeDomVirtualization';
    };
    DomVirtualTreeExtension.prototype.instantiateRenderers = function () {
        var rendererFactory = getValue('locator', this).getService('rendererFactory');
        getValue('addRenderer', rendererFactory)
            .apply(rendererFactory, [RenderType.Content, new DomVirtualTreeContentRenderer(getValue('parent', this), getValue('locator', this))]);
    };
    return DomVirtualTreeExtension;
}(GridDomVirtualization));
export { DomVirtualTreeExtension };
